"use client";
import React from "react";

import Image from "next/image";
interface User {
  data: any;
  logmobile?:string;
  logemail?:string;
  first_name?: string;
  last_name?: string;
  email?: string;
  address?: string;
  contact_number?: string;
  birthday?: string;
  profilePhoto?: string;

}
interface userProps {
  value: any;
  onChange: (value: any) => void;
  user: User;
  logmobile:string;
  logemail:string;
  first_name?: string;
  last_name?: string;
  email?: string;
  address?: string;
  contact_number?: string;
  birthday?: string;
  profile_image?: string;
}



const AccountForm: React.FC<userProps> = ({ user }) => {


  return (
    <div className="">
      <main className=" flex items-center justify-center px-4 py-8">
      <div className="w-full bg-white">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
       
          <span className="inline-flex items-center rounded-full bg-emerald-50 px-3 py-1 text-xs font-medium text-emerald-700 border border-emerald-200">
            Status: {user?.data?.status === "active" ? "Active" : "Inactive"}
          </span>
        </div>

        {/* Layout */}
        <div className="grid gap-6 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]">
          {/* Profile card */}
          <section className="bg-slate-50 border border-slate-200 rounded-2xl p-5 md:p-6 flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <div className="relative h-20 w-20 rounded-full overflow-hidden bg-slate-200">
                {/* <Image
                  src={user?.data?.imgpath}
                  alt={user?.data?.fulname}
                  className="object-cover"
                  width={100}
                  height={100}
                /> */}
              </div>
              <div>
                <h2 className="text-xl font-semibold text-slate-900">
                  {user?.data?.fulname}
                </h2>
                <p className="text-xs uppercase tracking-wide text-slate-500">
                  {user?.data?.role}
                </p>
                <p className="mt-1 text-xs text-slate-500">
                  Gender:{" "}
                  <span className="font-medium capitalize">
                    {user?.data?.ogender}
                  </span>
                </p>
              </div>
            </div>

            <div className="border-t border-slate-200 pt-4 grid gap-3 text-sm text-slate-700">
              <div className="flex justify-between">
                <span className="text-slate-500">Email</span>
                <span className="font-medium">{user?.data?.logemail}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-500">Mobile</span>
                <span className="font-medium">{user?.data?.logmobile}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-500">Country code</span>
                <span className="font-medium">+{88}</span>
              </div>
            </div>
          </section>

          {/* Health section */}
          <section className="flex flex-col gap-4">
            {/* Top stat cards */}
            <div className="grid gap-4 sm:grid-cols-3">
              <div className="bg-white border border-slate-200 rounded-xl p-4 shadow-sm">
                <p className="text-xs font-medium text-slate-500 uppercase">
                  BMI
                </p>
                <p className="mt-2 text-2xl font-semibold text-slate-900">
                  {user?.data?.mybmi}
                </p>
                <p className="mt-1 text-xs text-slate-500">
                  Body Mass Index (lb/in²)
                </p>
              </div>
              <div className="bg-white border border-amber-200 rounded-xl p-4 shadow-sm">
                <p className="text-xs font-medium text-amber-600 uppercase">
                  Category
                </p>
                <p className="mt-2 text-lg font-semibold text-amber-700">
                  {user?.data?.bmicat}
                </p>
                <p className="mt-1 text-xs text-amber-700">
                  Increased health risk
                </p>
              </div>
              <div className="bg-white border border-emerald-200 rounded-xl p-4 shadow-sm">
                <p className="text-xs font-medium text-emerald-600 uppercase">
                  Daily calories
                </p>
                <p className="mt-2 text-2xl font-semibold text-emerald-700">
                  {user?.data?.mycalory}
                </p>
                <p className="mt-1 text-xs text-emerald-700">
                  kcal/day target
                </p>
              </div>
            </div>

            {/* Detailed card */}
            <div className="bg-slate-50 border border-slate-200 rounded-2xl p-5 md:p-6 flex flex-col gap-4">
              <div className="flex items-center justify-between">
                <h3 className="text-sm font-semibold text-slate-900 uppercase tracking-wide">
                  Body metrics
                </h3>
                <span className="inline-flex items-center rounded-full bg-amber-50 px-3 py-1 text-[11px] font-medium text-amber-700 border border-amber-200">
                  Overweight range
                </span>
              </div>

              <div className="grid gap-4 sm:grid-cols-3 text-sm text-slate-700">
                <div className="flex flex-col">
                  <span className="text-slate-500">Height</span>
                  <span className="font-semibold">
                    {user?.data?.myhight} in
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="text-slate-500">Weight</span>
                  <span className="font-semibold">
                    {user?.data?.myweight} lb
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="text-slate-500">BMI status</span>
                  <span className="font-semibold text-amber-700">
                    {user?.data?.bmicat}
                  </span>
                </div>
              </div>

              <p className="text-xs text-slate-500 leading-relaxed">
                This summary is for monitoring only and does not replace
                professional medical advice. Please consult a clinician for a
                personalized health plan.
              </p>
            </div>
          </section>
        </div>
      </div>
    </main>
    </div>
  );
};

export default AccountForm;

 